import { Button, Group, Text } from '@mantine/core';
import type { SessionAutosaveStatus } from '../hooks/useSessionAutosave';

export function SessionAutosaveStatusText({
  status,
  error,
  onRetry,
}: {
  status: SessionAutosaveStatus;
  error?: string | null;
  onRetry?: () => void;
}): JSX.Element | null {
  if (status === 'idle') return null;

  if (status === 'error' || status === 'retrying') {
    return (
      <Group gap="xs" wrap="nowrap">
        <Text size="xs" c="red">
          {error?.trim() || 'Save failed'}
        </Text>
        {onRetry ? (
          <Button
            size="compact-xs"
            variant="subtle"
            color="red"
            loading={status === 'retrying'}
            onClick={onRetry}
          >
            Retry save
          </Button>
        ) : null}
      </Group>
    );
  }

  if (status === 'saving' || status === 'dirty') {
    return (
      <Text size="xs" c="dimmed">
        Saving…
      </Text>
    );
  }

  if (status === 'saved') {
    return (
      <Text size="xs" c="dimmed">
        Saved
      </Text>
    );
  }

  return null;
}
